import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import DataWrapper from '../../principal/containers/DataWrapper';
import {TabelaFluxo} from "../../comum/components/TabelaFluxo";
import HorasTrabalhadasPendentesStore from "../stores/HorasTrabalhadasPendentesStore";
import {
    formatarDataMesAno, formatarNomeProduto,
    motivoContratacaoFormatter, mudarDiasAlerta, nullable, ordenarData, ordenarSLA,
    slaFormatter
} from "../../../utils/formatar";
import ParametrosGeraisStore from "../../administracao/stores/ParametrosGeraisStore";
import {formatarDataISO8601} from "../../../utils/formatar";
import {Modal, ModalBody, Row, Col, ModalFooter, ModalHeader, Button} from "reactstrap";
import Dropzone from 'react-dropzone'
import loading from '../../../assets/images/ajax-loader.gif';
import {LoadingBlockFields} from "../../comum/components/LoadingBlockFields";
import {sortAlphaNum} from "../../../utils/ordenar";
import {formatarBoolean} from "../../../utils/functions";


@inject("store")
@DataWrapper
@observer
export class HorasTrabalhadasPendentes extends Component {
    constructor(props) {
        super(props);
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        this.modalStore                 = this.props.store.modalStore;
        this.controller                 = new HorasTrabalhadasPendentesStore();
        this.parametrosGeraisStore = new ParametrosGeraisStore();
    }

    componentWillMount() {
        //TODO: usar component Modal
        this.modalStore.setSubmitted(false);
        this.modalStore.setSubmitMensagemErro("");
        this.modalStore.setLoading(false);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Horas trabalhadas pendentes");

        this.controller.carregarLista();
        this.parametrosGeraisStore.carregarLista();

        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            }
        ]);
    }

    obterTituloMobile = (objeto) => {
        return objeto.nomeTarefa;
    };

    obterTituloMobile = (objeto) => {
        return  (objeto.idSolicitacaoExibicao != null ? "#" + objeto.idSolicitacaoExibicao + " - " : "") + objeto.tarefa+ " de " +objeto.nomeProfissional;
    };


    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "SLA: "}<div  style={{display: "inline-block"}}>{slaFormatter(objeto.sla, objeto)}</div><br/>
                { "CPF do profissional: " + nullable(objeto.cpf)}<br/>
                { "Prazo: " + nullable(formatarDataISO8601(objeto.prazo))}<br/>
                { "Solicitante: " + nullable(objeto.nomeSolicitante)}<br/>
                { "Cargo: " + nullable(objeto.cargo)}<br/>
                { "Motivo de contratação: " + nullable(motivoContratacaoFormatter(objeto.motivoContratacao))}<br/>
                { "Justificativa: " + nullable(objeto.justificativa)}<br/>
                { "Projeto/centro de resultado/finalidade: " +  nullable(formatarNomeProduto(objeto.produto))}<br/>
                { "Local trabalho MOT: " + nullable(objeto.localTrabalho)}<br/>
                { "Competência: " + nullable(formatarDataMesAno(objeto.mesCompetencia))}<br/>
                { "Data de início: " + nullable(formatarDataISO8601(objeto.dataInicio))}<br/>
                { "Data de término: " + nullable(formatarDataISO8601(objeto.dataFim))}
            </div>
        )
    };

    formatoJornada = (cell) => {
        return cell ? cell + " horas" : "";
    };

    importarPlanilha = () => {
        this.controller.toogleImportModal();
    }

    renderModal(){
        return (
            <Modal 
                backdrop={'static'} 
                keyboard={!this.modalStore.loading} 
                isOpen={this.controller.importModal} 
                style={{ zIndex: 9999 }}>
                <ModalHeader>Importar planilhas de hora extra</ModalHeader>
                <ModalBody>
                    <LoadingBlockFields carregando={this.controller.isLoading}>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Dropzone
                                style={{width: "100%", height: "200px", borderWidth: "2px", borderColor: "rgb(102, 102, 102)", borderStyle: "dashed", borderRadius: "5px", display: "table" }}
                                onDrop={(accepted, rejected) => { this.controller.pushFiles({ accepted, rejected }); }}
                                disabled={ this.controller.files.length > 0 ? true : false }
                            >
                                <p style={{textAlign: "center", verticalAlign: "middle", display: "table-cell"}}>Arraste um arquivo para cá <br /> ou, se preferir...<br /> clique e selecione um arquivo do computador.</p>
                            </Dropzone>
                        </Col>
                    </Row>
                    <br />
                    {
                        this.controller.files.length > 0 &&
                        <Row>
                            <Col xs={12} md={12} lg={12} className="alert-info">
                                <h4>Planilha aceita:</h4>
                                <ul>
                                    {
                                        this.controller.files.map(f => <li key={f.name}>● {f.name} - {f.size} bytes</li>)
                                    }
                                </ul>
                            </Col>
                        </Row>
                    }
                    {
                        this.controller.rejectedfiles.length > 0 &&
                        <Row>
                            <Col xs={12} md={12} lg={12} className="alert-item">
                                <h4>Arquivos inválidos:</h4>
                                <ul>
                                    {
                                        this.controller.rejectedfiles.map(f => <li key={f.name}>● {f.name} </li>)
                                    }
                                </ul>
                            </Col>
                        </Row>
                    }
                    {
                        this.controller.sucessoImportacao.length > 0 &&
                        <Row>
                            <Col xs={12} md={12} lg={12} className="sucess-info">
                                <h4>Dados importados:</h4>
                                <ul>
                                    {
                                        this.controller.sucessoImportacao.map(s => <li key={s.linhaExcel}>● Linha: {s.linhaExcel} cpf: {s.cpf} </li>)
                                    }
                                </ul>
                            </Col>
                        </Row>
                    }
                    {
                        this.controller.errorsImportacao.length > 0 &&
                        <Row>
                            <Col xs={12} md={12} lg={12} className="error-info">
                                <h4>Erros de importação:</h4>
                                <ul>
                                    {
                                        this.controller.errorsImportacao.map(f => <li key={f.id + f.label}>● {f.plam} linha {f.id}: {f.label} </li>)
                                    }
                                </ul>
                            </Col>
                        </Row>
                    }
                    </LoadingBlockFields>
                </ModalBody>
                <ModalFooter>
                    <p>{ this.controller.errorMensage }</p>
                    {this.modalStore.loading ? <img src={loading} alt="loading" className="loading"/> : ""}
                    <div>
                        <Button color="primary" disabled={this.modalStore.loading || this.controller.listaDeArquivosVazia()} onClick={() => this.controller.sendFiles()} >Enviar</Button>
                        <Button color="secondary" disabled={this.modalStore.loading} onClick={() => this.controller.cleanFiles()}>Limpar</Button>
                        <Button color="secondary" disabled={this.modalStore.loading} onClick={() => this.controller.toogleImportModal()}>Cancelar</Button>
                    </div>
                </ModalFooter>
            </Modal>
        );
    }


    render() {
        mudarDiasAlerta(this.parametrosGeraisStore.parametros.slaGrlTmpAvaliarResponder)
        //TODO: inserir as outras colunas
        const colunas = [
            {
                field: "idSolicitacaoExibicao",
                label: "#",
                funcaoOrdenacao: sortAlphaNum.bind("idSolicitacaoExibicao")
            },{
                field: "cpf",
                label: "CPF do Profissional"
            },{
                field: "nomeProfissional",
                label: "Nome do profissional"
            },{
                field: "tarefa",
                label: "Tarefa",
            },{
                field: "prazo",
                label: "Prazo",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("prazo")
            },{
                field: "sla",
                label: "SLA",
                dataFormat: slaFormatter,
                funcaoOrdenacao: ordenarSLA.bind("prazo")
            },{
                field: "indSalarioImportado",
                label: "Timesheet atualizado",
                dataFormat: formatarBoolean
            },{
                field: "gestorSolicitante",
                label: "Gestor"
            },{
                field: "cargo",
                label: "Cargo"
            }/*,{
                field: "motivoContratacao",
                label: "Motivo contratação",
                dataFormat: motivoContratacaoFormatter
            },{
                field: "produto",
                label: "Projeto/centro de resultado/finalidade"
            }*/,{
                field: "localTrabalho",
                label: "Local de trabalho"
            },{
                field: "mesCompetencia",
                label: "Competência",
                dataFormat: formatarDataMesAno,
                funcaoOrdenacao: ordenarData.bind("mesCompetencia")
            },{
                field: "dataInicio",
                label: "Data inicial",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("dataInicio")
            },{
                field: "dataFim",
                label: "Data final",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("dataFim")
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                        <TabelaFluxo
                            keyField={"idTarefaBpm"}
                            nomeFluxo={'Horas trabalhadas'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.tarefas}
                            colunas={colunas}
                            temBusca={true}
                            //TODO: novas acoes devem ser criadas em TabelaFluxo
                            parametroVisualizar={"idTarefaBpm"}
                            acoesItens={["visualizar"]}
                            acoesMultiplas={this.controller.acoesMultiplas}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            upload={this.importarPlanilha}
                            loading={this.controller.loading}
                            controller={this.controller}
                            fluxoNovo={true}
                        />
                    </div>
                    {this.renderModal()}
                </div>
            </div>
        );
    }
}

